
export default {
  props: ["building"],
  data() {
    return {
      drag: false,
      showBaseMap: false,
      isShowAll: true,
      isShow: false,
      radioChecked1: [],
      zhuaiCheckeds: [],
      checkedVals: [],
      baseOpt: 100, // 底图透明度
      showDraw: true,
    };
  },
  mounted() {},
  methods: {
    dragEnd(val) {
      let ar = [];
      let ar1 = [];
      $(".table-right-menu-content").each(function () {
        let lay = $(this).attr("layer");
        let data = $(this).attr("data");
        if (lay) {
          ar.push(lay);
          ar1.push(JSON.parse(data));
        }
      });
      if (ar.length == 2) {
        ar.forEach((item, index) => {
          if (index > 0) {
            this.building.moveLayer(item, ar[index - 1]);
          }
        });
      } else {
        ar.forEach((item, index) => {
          if (index > 0) {
            this.building.moveLayer(ar[index - 1], item);
          }
        });
      }
      this.zhuaiCheckeds = ar1;
      this.$emit("dragEnd", ar1.reverse());
    },
    toggleAll() {
      this.isShowAll = !this.isShowAll;
    },
    // closeLayers
    closeLayers() {
      this.isShow = false;
    },
    closeItem(item, i) {
      let k = this.radioChecked1.findIndex((data) => data == item.keyName);
      this.radioChecked1.splice(k, 1);
      this.changeLayers(this.radioChecked1);
      this.$nextTick(() => {
        this.checkedVals.splice(i, 1);
        if (this.checkedVals.length == 0) {
          this.closePop();
        }
      });
    },
    // 修改底图透明度
    changeBaseMap(e) {
      let opt = "raster-opacity";
      if ($(".vr-card2").hasClass("active")) {
        this.building.setPaintProperty("gd-vector", opt, parseInt(e, 10) / 100);
      } else if ($(".vr-card").hasClass("active")) {
        this.building.setPaintProperty(
          "gd-vector-yingxiang",
          opt,
          parseInt(e, 10) / 100
        );
      }
    },
    closePop() {
      this.isShow = false;
    },
    changeOpts(e, key, i) {
      this.checkedVals[i].optVal = e;
      let opt = "";
      if (key.indexOf("rail") > -1) {
        opt = "circle-opacity";
      } else if (key.indexOf("line") > -1 || key.indexOf("road") > -1) {
        opt = "line-opacity";
      } else if (key.indexOf("buildings") > -1) {
        opt = "fill-extrusion-opacity";
      } else {
        opt = "fill-opacity";
      }
      if (key.indexOf("field_txt") > -1) {
        opt = "icon-opacity";
      }
      if (key instanceof Array) {
        key = key[1];
      }
      if (this.checkedVals[i].isImage) {
        opt = "raster-opacity";
        let lc = false;
        this.building.getStyle().layers.forEach((layer) => {
          if (
            layer.id.endsWith("_unlabel") &&
            this.building.getLayoutProperty(layer.id, "visibility") == "visible"
          ) {
            let lay = layer.id.replace("_unlabel", "");
            if (key == lay) {
              console.log(lay);
              this.building.setPaintProperty(
                layer.id,
                opt,
                parseInt(e, 10) / 100
              );
              lc = true;
            }
          }
        });

        if (!lc) {
          this.building.setPaintProperty(key, opt, parseInt(e, 10) / 100);
        }
      } else {
        this.building.setPaintProperty(key, opt, parseInt(e, 10) / 100);
      }
    },
    changeLayers(e) {
      this.$emit("emitLayers", e);
    },
    arrayMatch(firstArray, secondArray) {
      // 使用 keyName 创建对象的映射，以便在 O(1) 时间内查找元素
      let firstMap = {};
      let secondMap = {};

      firstArray.forEach((item) => {
        firstMap[item.keyName] = item;
      });

      secondArray.forEach((item) => {
        secondMap[item.keyName] = item;
      });

      // 确保 firstArray 包含 secondArray 中的所有元素
      for (let key in secondMap) {
        if (!firstMap.hasOwnProperty(key)) {
          // 将元素插入到 firstArray 的开头
          firstArray.unshift(secondMap[key]);
        }
      }

      // 删除 firstArray 中 secondArray 不包含的元素
      firstArray = firstArray.filter((item) =>
        secondMap.hasOwnProperty(item.keyName)
      );

      return firstArray;
    },
    // 显示底图
    doShowBaseMap(showBaseMap) {
      this.showBaseMap = showBaseMap;
      if (this.showBaseMap) {
        this.isShow = true;
      }
    },
    showPop(checkedVals) {
      if (checkedVals.length > 0) {
        this.isShow = true;
        this.showDraw = false;
        this.checkedVals = this.arrayMatch(
          this.zhuaiCheckeds,
          checkedVals.reverse()
        );
        this.radioChecked1 = this.checkedVals.map((item) => item.keyName);

        this.$nextTick(() => {
          this.showDraw = true;
        });
      } else {
        this.checkedVals = [];
        this.isShow = false;
      }
    },
  },
};
